import baseUrl from "../lightingApiHost";
import { callApi } from "./util";

const discardOverride = overrideId => {
  const url = `${baseUrl}overrides/${overrideId}/discard`;
  const config = {
    method: "POST"
  };
  return callApi(url, config);
};

const getOverrideStage = overrideId => {
  const url = `${baseUrl}overrides/${overrideId}/stage`;
  return callApi(url);
};

export default {
  discardOverride,
  getOverrideStage
};
